import { Injectable } from '@angular/core';
import { bleachrHTTP } from '../_classes';
import { environment } from 'src/environments/environment';
import { GolfWeatherModel } from '../_interfaces';

@Injectable({
    providedIn: 'root'
})
export class WeatherService {

    constructor(
        private httpPromise: bleachrHTTP
    ) { }

    async get__weather(lat: string, long: string) {
        try {
            return await this.httpPromise
                .get<{ data: GolfWeatherModel }>(`${environment.ELIXIR_API_FOUR}/weather?lat=${lat}&lng=${long}`)
                .then((res) => {
                    return res.data
                })
                .catch((err) => {
                    throw err
                })
        } catch (err) {
            throw err
        }
    }

    async get__weather__v2(lat: string, long: string) {
        try {
            return await this.httpPromise
                .get<{ data: GolfWeatherModel }>(`${environment.ELIXIR_API_FOUR}/weather/forecast?lat=${lat}&lng=${long}`)
                .then((res) => {
                    return res.data
                })
                .catch((err) => {
                    throw err
                })
        } catch (err) {
            throw err
        }
    }
}
